<template>
  <div class="house">
    <div class="rightmouse"
         :style="{
        top: rightMouseTop + 'px',
        left: rightMouseLeft + 'px',
        opacity: rightMouseFlag ? '1' : '0',
      }">
      <p>© 图片版权保护</p>
    </div>

    <div class="centerbody"
         @click="openList">
      <div v-if="!showGifFlag">
        <div v-if="!isPic"
             class="piclist">
          <section v-if="picList.length !== 0">
            <div class="img-wrapper"
                 v-for="(item, index) in picList"
                 :key="index">
              <el-image class="img"
                        @contextmenu.prevent="rightShow($event)"
                        ondragstart="return false;"
                        @click="
                  picList[0].src !== require('@/assets/house/grey.png') &&
                  item.errortext !== 'error' &&
                    openDialog(index, item)
                "
                        ref="loveImg"
                        :src="item.src">
                <div slot="error"
                     class="image-slot">
                  <img src="@/assets/house/onloadpicerror.png"
                       alt="" />
                </div>
              </el-image>
              <el-tooltip class="item"
                          effect="dark"
                          content="删除图片"
                          placement="top">
                <div v-if="powersObj.manageAtlas"
                     @click.stop="deletePic(item, index)"
                     class="delete">
                  <img src="@/assets/piclist/delete.png"
                       alt />
                </div>
              </el-tooltip>

              <el-tooltip class="item"
                          effect="dark"
                          content="选用图片"
                          placement="top">
                <div @click.stop="lovePic(item, index)"
                     v-if="powersObj.selectPicture"
                     class="love">
                  <template v-if="isForestall">
                    <img v-if="loveList.indexOf(item.resourceId) === -1"
                         src="@/assets/piclist/love.png"
                         alt />
                    <img v-if="loveList.indexOf(item.resourceId) > -1"
                         src="@/assets/piclist/lovec.png"
                         alt />
                  </template>
                  <template v-else>
                    <img v-if="loveList.indexOf(item.id) === -1"
                         src="@/assets/piclist/love.png"
                         alt />
                    <img v-if="loveList.indexOf(item.id) > -1"
                         src="@/assets/piclist/lovec.png"
                         alt />
                  </template>

                </div>
              </el-tooltip>

              <el-tooltip class="item"
                          effect="dark"
                          content="修改图片说明"
                          placement="top">
                <div @click.stop="openChangeDesc(item)"
                     v-if="powersObj.manageAtlas"
                     class="changedesc">
                  <img src="@/assets/sreenpic/desc.png"
                       alt="" />
                </div>
              </el-tooltip>
            </div>

            <img v-if="showLoading"
                 class="myloading"
                 width="200px"
                 src="@/assets/blue-preloader.gif"
                 alt />
          </section>

          <template v-if="picList.length === 0 && !searchLoading">
            <div class="nopic">
              <img src="@/assets/piclist/nonr.png"
                   alt />
            </div>
          </template>
        </div>
      </div>
      <div v-else
           style="
          height: 500px;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        ">
        <img width="200px"
             height="200px"
             src="@/assets/blue-preloader.gif"
             alt />
      </div>
    </div>

    <!-- 图片点击弹窗 -->
    <el-dialog :visible.sync="dialogVisible"
               width="90%"
               top="12vh"
               class="seePic"
               :show-close="false">
      <!-- 关闭按钮 -->
      <div @click="dialogVisible = false"
           class="close">
        <img :style="{ 'margin-top': displayResolution < 1600 ? '-2px' : '0px' }"
             src="@/assets/picbrowse/close.png"
             alt="" />
      </div>

      <div class="left">
        <div class="pic"
             v-loading="imgLoading"
             element-loading-text="正在加载图片中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)">
          <!-- <el-switch style="position:absolute;top:20px;right:20px;"
                     v-model="switechValue"
                     @change="clearLargeAndSmall">
          </el-switch> -->
          <div class="imgBj"
               ref="imgBj">
            <!-- <img ref="imgPic"
                 height="78%"
                 v-drag
                 v-lazy="choosePicMsg.src"
                 v-if="!switechValue"> -->
            <img ref="imgPic"
                 @contextmenu.prevent="rightShow($event)"
                 ondragstart="return false;"
                 height="98%"
                 :style="seeFull ? 'cursor:zoom-out' : 'cursor:zoom-in'"
                 @click="seeBigSmall"
                 v-lazy="choosePicMsg.src" />
            <div v-if="switechValue"
                 class="origin">
              <div class="faceBorder"
                   :style="
                  'position: absolute;display:flex;justify-content:center;align-items:center;border:1px dashed #00ccff;;height:' +
                  item.height +
                  'px;width:' +
                  item.width +
                  'px;top:' +
                  item.top +
                  'px;left:' +
                  item.left +
                  'px;'
                "
                   v-for="(item, index) in choosePicMsg.faceInfo"
                   :key="index">
                <div style="width: 93%; height: 93%; border: 1px dotted #666">
                  <div class="yuan"
                       :style="{
                      left: item.width - 20 + 'px',
                      top: item.height / 2 + 'px',
                    }"></div>
                  <div class="faceName"
                       :title="item.peopleName"
                       @click="powersObj.myFace && !seeFull && getFaceId(1,item, index)"
                       :style="{
                      left: item.width - 10 + 'px',
                      top: item.height / 2 - 10 + 'px',
                    }">
                    {{
                      item.peopleName.length > 11
                        ? item.peopleName.substring(0, 11) + "…"
                        : item.peopleName
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div @click="bigLeft"
                 class="leftjt">
              <div class="message"
                   v-show="showMessageLeft">这是第一张哟~</div>
            </div>
            <div @click="bigRight"
                 class="rightjt">
              <div class="message"
                   v-show="showMessageRight">这是最后一张哟~</div>
            </div>
            <i @click="picRotateRight"
               v-if="seeFull"
               class="el-icon-refresh-right"
               style="
                position: absolute;
                bottom: 20px;
                left: 45%;
                font-size: 30px;
              "></i>
            <i @click="picRotateLeft"
               v-if="seeFull"
               class="el-icon-refresh-left"
               style="position: absolute; bottom: 20px; font-size: 30px"></i>
          </div>
          <!-- <img height="78%" :src="choosePicMsg.src"> -->

          <!-- <div class="picBtn"
               v-if="!switechValue">
            <i @click="picRotateRight"
               class="el-icon-refresh-right"></i>
            <i @click="picLarge"
               class="el-icon-zoom-in"></i>
            <i @click="picSmall"
               class="el-icon-zoom-out"></i>
            <i @click="picRotateLeft"
               class="el-icon-refresh-left"></i>
          </div> -->
        </div>

        <div class="picinf disflex">
          <p></p>
          <!-- <p class="picinfleft">{{atlasInfo.name}} / 共<span>{{atlasInfo.pictureCount}}</span>张</p> -->
          <div class="picinfright disflex"
               v-if="choosePicMsg.errortext !== 'error'">
            <!-- v-if="!isSimple" -->
            <div @click.stop="seeFace"
                 v-if="!isSimple"
                 class="disflex face"
                 :style="{
                background: !switechValue
                  ? 'url(' +
                    require('@/assets/picbrowse/face.png') +
                    ') no-repeat'
                  : 'url(' +
                    require('@/assets/picbrowse/facehover.png') +
                    ') no-repeat',
              }">
              <div class="icon"></div>
              <p :style="{ color: switechValue ? '#6ea4ff' : '#FFFFFF' }">
                人脸({{ faceLength }})
              </p>
            </div>
            <div v-if="powersObj.createAtlas"
                 @click.stop="lovePic"
                 class="disflex spare"
                 :style="{
                background: !haslovechange
                  ? 'url(' +
                    require('@/assets/picbrowse/spare.png') +
                    ') no-repeat'
                  : 'url(' +
                    require('@/assets/picbrowse/sparelove.png') +
                    ') no-repeat',
              }">
              <div class="icon"></div>
              <p>选用</p>
            </div>
            <div v-if="powersObj.manageAtlas"
                 @click="deletePic"
                 class="disflex delete">
              <div class="icon"></div>
              <p>删除</p>
            </div>
          </div>
        </div>

        <div ref="piclist"
             class="piclist">
          <div v-if="picAllListFlag >= 13 || scroll < -1"
               @click="smallLeft"
               class="leftjt">
            <i style="font-size: 30px"
               class="el-icon-arrow-left"></i>
          </div>

          <div ref="picalllist"
               style="display: flex; transition: 1s">
            <div @click="picListClick(e, i)"
                 v-for="(e, i) in picList"
                 :key="i">
              <!-- <img :src="e.src" :class="picAllListFlag === i || choosePicMsg.id === i ? 'picimg active':'picimg'" /> -->
              <div :style="{
                  backgroundImage: 'url(' + e.src + ')',
                  cursor: 'pointer',
                }"
                   @contextmenu.prevent="rightShow($event)"
                   ondragstart="return false;"
                   :class="
                  picAllListFlag === i || choosePicMsg.myId === i
                    ? 'picimg active'
                    : 'picimg'
                "></div>
            </div>
          </div>

          <div v-if="picCha !== scroll && picList.length > 13"
               @click="smallRight"
               class="rightjt">
            <i style="font-size: 30px"
               class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

      <div class="right">
        <div class="title">
          <p>图片信息</p>
        </div>
        <!-- <p><div class="key">用户名</div><div class="value">可爱无敌美少女</div></p> -->
        <div v-if="isForestall"
             style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 45px">上传者</div>
          ： <span>{{ choosePicMsg.atlasCreateUserName }}</span>
        </div>
        <div v-else
             style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 45px">上传者</div>
          ： <span>{{ choosePicMsg.createUserName }}</span>
        </div>
        <div v-if="isForestall"
             style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">所属图集</div>
          ： <span>{{ atlasName }}</span>
        </div>
        <div v-else
             style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">所属图集</div>
          ： <span>{{ altasName }}</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">所属图库</div>
          ： <span>{{ choosePicMsg.libName }}</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">拍摄时间</div>
          ： <span>{{ picExif.CreateAtMy || "无" }}</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">上传时间</div>
          ： <span>{{ picInfo.createAt || "无" }}</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">相机品牌</div>
          ： <span>{{ picExif.Make || "暂无" }}</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">图片尺寸</div>
          ： <span>{{ picInfo.picW }}*{{ picInfo.picH }}像素</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">图片大小</div>
          ： <span>{{ picInfo.fileSize }}MB</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">图片格式</div>
          ： <span>{{ picInfo.format }}</span>
        </div>
        <div v-if="picExif.ExposureTime"
             style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">曝光时间</div>
          ： <span>{{ picExif.ExposureTime }}秒</span>
        </div>
        <div v-if="!picExif.ExposureTime"
             style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">曝光时间</div>
          ： <span>暂无</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">ISO速度</div>
          ： <span>{{ picExif.ISOSpeedRatings || "暂无" }}</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">图片焦距</div>
          ： <span>{{ picExif.FocalLength || "暂无" }}</span>
        </div>

        <div style="margin-top: 25px"
             class="title"
             v-if="choosePicMsg.desc">
          <p>图片说明</p>
        </div>

        <p style="line-height: 26px; padding-left: 8px">
          {{ choosePicMsg.desc }}
        </p>

        <div style="margin-top: 25px"
             class="title"
             v-if="choosePicMsg.labels.length > 0 && !isSimple">
          <p>智能标签</p>
          <div class="alert">仅供参考</div>
        </div>

        <div v-if="!isSimple"
             style="
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;
            margin-top: 10px;
          ">
          <div style="margin-left: 5px; margin-bottom: 5px"
               v-for="(e, i) in choosePicMsg.labels"
               :key="i">
            <el-tag>{{ e }}</el-tag>
          </div>
        </div>

        <div style="margin-top:25px;"
             class="title"
             v-if="choosePicMsg.faceInfo.length > 0 && !isSimple">
          <p>人物</p>
          <div class="alert">仅供参考</div>
        </div>

        <div v-if="!isSimple"
             style="display:flex;align-items: center;flex-wrap: wrap;width:100%;margin-top:10px;">
          <div style="margin-left:5px;margin-bottom:5px;cursor: pointer;"
               v-for="(e,i) in choosePicMsg.faceInfo"
               :key="i">
            <el-tag type="success"
                    @click.stop="powersObj.myFace && seepersonallface(e)">{{e.peopleName}}</el-tag>
          </div>
        </div>

        <div class="msg disflex"
             v-if="false">
          <div class="picmsg">
            <p>{{ choosePicMsg.shareCount }}</p>
            <div>浏览量</div>
            <img src="@/assets/picbrowse/see.png"
                 alt="" />
          </div>
          <div class="picmsg">
            <p>{{ choosePicMsg.pushCount }}</p>
            <div>推送量</div>
            <img src="@/assets/picbrowse/msgpush.png"
                 alt="" />
          </div>
          <div class="picmsg">
            <p>{{ choosePicMsg.downloadCount }}</p>
            <div>平台数</div>
            <img src="@/assets/picbrowse/platform.png"
                 alt="" />
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="clickFaceDialog"
               width="30%"
               :before-close="clickFaceDialogHandleClose">
      <div slot="title"
           class="header-title"
           :style="{
          padding: '15px 20px',
          'box-sizing': 'border-box',
          backgroundColor: isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3',
        }">
        <div>提示</div>
      </div>
      <el-radio v-model="seeOrUpdateFace"
                label="1">修改</el-radio>
      <el-radio v-model="seeOrUpdateFace"
                label="2">查看</el-radio>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="clickFaceDialogHandleClose">取 消</el-button>
        <el-button type="primary"
                   @click="clickFaceDialogFun">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="peopleDialogVisible"
               width="30%"
               :before-close="handleClose">
      <div slot="title"
           class="header-title"
           :style="{
          padding: '15px 20px',
          'box-sizing': 'border-box',
          backgroundColor: isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3',
        }">
        <div>标记人物</div>
      </div>
      <el-form :model="faceRuleForm"
               v-loading="peopleLoading"
               :rules="faceRules"
               ref="faceRuleForm"
               label-width="100px"
               class="demo-ruleForm">
        <el-form-item label="人物分类："
                      prop="peopleClass">
          <el-select v-model="faceRuleForm.peopleClass"
                     style="width: 100%"
                     placeholder="请选择人物分类">
            <el-option v-for="item in peopleClass"
                       :key="item"
                       :label="item"
                       :value="item"
                       v-html="'<span style=color:#303030;>' + item + '</span>'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区："
                      prop="region">
          <el-select v-model="faceRuleForm.region"
                     style="width: 100%"
                     placeholder="请选择地区">
            <el-option v-for="item in region"
                       :key="item"
                       :label="item"
                       :value="item"
                       v-html="'<span style=color:#303030;>' + item + '</span>'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名："
                      prop="name">
          <el-input v-model="faceRuleForm.name"
                    @input="myInput"></el-input>
        </el-form-item>
      </el-form>
      <div style="width: 90%; margin: 20px auto"
           v-if="faceInputFlag">
        <p style="margin-top: 30px; margin-bottom: 10px">
          注：如人物已存在，您可以通过输入姓名检索并合并
        </p>
        <el-table :data="faceData"
                  style="width: 100%"
                  border>
          <el-table-column prop="peopleName"
                           label="人物姓名"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-image style="
                  width: 22px;
                  height: 22px;
                  border-radius: 50%;
                  margin-left: 10px;
                "
                        :src="scope.row.peopleLogo"
                        :preview-src-list="[scope.row.peopleLogo]"></el-image>
              <span>{{ scope.row.peopleName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createUserInfo.name"
                           label="创建人">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <p @click="mergeFace(scope)"
                 style="color: #185ed3; cursor: pointer">
                合并
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   :style="{
            border: 'none',
            backgroundColor: isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3',
          }"
                   @click="beSure('faceRuleForm')">确 定</el-button>
      </span>
    </el-dialog>

    <seePeopleFace @clickFaceDialogHandleClose="clickFaceDialogHandleClose"
                   ref="seePeopleFace"></seePeopleFace>

    <changedescdialog :message="message"
                      :dialogVisible="descdialogVisible"
                      @handleClose="deschandleClose"
                      @changeDesc="changeDesc"></changedescdialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { powersObj, allowLib, allowPushChannel } from "@/constants/powers";
import { formatConversion } from "@/plugins/getdate";
import { changedescdialog } from "@/components/index";
import { seePeopleFace } from "@/components/index";
import { picPrefix } from "@/constants/piccommon";
import { fullScreen, exitFullscreen, checkFull } from "@/plugins/fullScreen";
import {
  listAtlasPictures,deletePicture, updatePicture,getPictures
} from "@/api/picture";
import { errorPic } from "@/plugins/errorPic";
import { listMyPowerLib } from "@/api/lib";
import { listUser } from "@/api/user";
import { searchAtlas, searchPicture, advSearchPicture } from "@/api/search";
import { getAtlasSonIds, generateIndexPic } from "@/api/atlas";
import { addPeople, getPeopleConstant, listPeople } from "@/api/people";
import { listWorkgroup } from "@/api/workgroup";
import { listPeopleFaceByFileId, setPeopleFaceAccess } from "@/api/peopleFace";
import { myPictureNeed } from "@/api/pictureNeed";
import { listAllowPushChannel } from "@/api/pushChannel";
import { setUserSetting, getUserSetting } from "@/api/config";
import { addPicturePackage, getPicturePackage } from "@/api/picturePackage";
import { getLib } from "@/api/lib";
export default {
  components: { changedescdialog, seePeopleFace },
  computed: {
    ...mapGetters(["createUid"]),
  },
  data () {
    return {
      //搜索框样式
      atlascss: 'atlaswk',
      piccss: 'picwk',
      //判断下拉框
      isLibrary: false, //所属图库
      isTheme: false, //图片主题
      isEnvironment: false, //所属环境
      isContributors: false, //投稿人
      isPeopleFace: false, //人物
      isTime: false, //时间
      isTakeTime: false, //拍摄时间
      isSort: false, //排序

      library: "",
      theme: "",
      environment: "",
      contributors: "",
      peopleFace: "",
      time: false,
      takeTime: false,
      formaTimeStart: "",
      formaTimeEnd: "",
      takeTimeStart: "",
      takeTimeEnd: "",
      sort: "",

      //图库列表
      libList: [],
      libFlag: -1,

      //图片主题
      themeList: [
        {
          id: -1,
          name: "不限",
        },
        {
          id: "亲子活动",
          name: "亲子活动",
        },
        {
          id: "体育赛事",
          name: "体育赛事",
        },
        {
          id: "建设",
          name: "建设",
        },
        {
          id: "劳作",
          name: "劳作",
        },
        {
          id: "开会",
          name: "开会",
        },
        {
          id: "调研",
          name: "调研",
        },
        {
          id: "抗洪抢险",
          name: "抗洪抢险",
        },
        {
          id: "春节",
          name: "春节",
        },
        {
          id: "演讲",
          name: "演讲",
        },
        {
          id: "采访",
          name: "采访",
        },
      ],
      themeFlag: -1,

      //所属环境
      environmentList: [
        {
          id: -1,
          name: "不限",
        },
        {
          id: "会场",
          name: "会场",
        },
        {
          id: "农田",
          name: "农田",
        },
        {
          id: "办公室",
          name: "办公室",
        },
        {
          id: "医院",
          name: "医院",
        },
        {
          id: "商超",
          name: "商超",
        },
        {
          id: "城市",
          name: "城市",
        },
        {
          id: "山川",
          name: "山川",
        },
        {
          id: "工厂",
          name: "工厂",
        },
        {
          id: "星空",
          name: "星空",
        },
        {
          id: "校园",
          name: "校园",
        },
        {
          id: "水源",
          name: "水源",
        },
        {
          id: "街道",
          name: "街道",
        },
      ],
      environmentFlag: -1,

      //投稿人
      contributorList: [],
      contributorFlag: -1,
      contributor: "",

      //人物
      peopleFaceList: [],
      peopleFaceFlag: -1,
      peopleFace: "",

      //时间
      timeStart: "",
      timeEnd: "",
      peopleFaceSearch: "",
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.timeStart) {
            return time.getTime() <= this.timeStart - 1000;
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.timeEnd) {
            return time.getTime() >= this.timeEnd + 1000;
          }
        },
      },

      //拍摄时间
      timeTakeStart: "",
      timeTakeEnd: "",
      pickerTakeOptionsEnd: {
        disabledDate: (time) => {
          if (this.timeTakeStart) {
            return time.getTime() <= this.timeTakeStart - 1000;
          }
        },
      },
      pickerTakeOptionsStart: {
        disabledDate: (time) => {
          if (this.timeTakeEnd) {
            return time.getTime() >= this.timeTakeEnd + 1000;
          }
        },
      },

      //排序列表
      sortList: [
        {
          id: 0,
          name: "按时间从近到远排列",
        },
        {
          id: 1,
          name: "按时间从远到近排列",
        },
      ],
      sortFlag: 0,

      //检索内容
      keyword: "",

      //判断搜索内容
      isPic: true,
      searchFlag: true,

      //图集列表
      atlasList: [],
      pageSizeAtlas: 30,
      pageAtlas: 0,
      totalAtlas: 0,
      picList: [],
      pageSizePic: 50,
      pagePic: 0,
      totalPic: 0,
      //gifloading
      showGifFlag: false,
      //滚动加载loading
      showLoading: false,

      searchLoading: false,

      //推送渠道
      pushdialogVisible: false,
      pushList: [],
      pushIndex: 0,
      template: "",
      pushChannelId: "",
      //推送至东方
      dfdialogVisible: false,
      dfmyform: {
        name: "",
        note: "",
        createUid: this.createUid,
        id: "",
      },
      dfrules: {
        name: [{ required: true, message: "请填写标题", trigger: "change" }],
      },
      //推送至图片邀约
      mydialogVisible: false,
      myform: {
        name: "",
        note: "",
        createUid: this.createUid,
        id: "",
      },
      rules: {
        name: [{ required: true, message: "请选择模板", trigger: "change" }],
      },
      picInviteList: [],
      //推送到用户
      dialogVisibleUser: false,

      userForm: {
        name: "",
        user: "",
        createUid: this.createUid,
        note: "",
      },
      userRules: {
        name: [{ required: true, message: "请输入标题", trigger: "change" }],
        user: [{ required: true, message: "请选择用户", trigger: "change" }],
      },
      userList: [],

      //分享到工作圈
      dialogVisibleWork: false,
      shareAtlasId: 0,
      workForm: {
        name: "",
        work: "",
        createUid: this.createUid,
        note: "",
      },
      workRules: {
        name: [{ required: true, message: "请输入标题", trigger: "change" }],
        work: [{ required: true, message: "请选择工作圈", trigger: "change" }],
      },
      workList: [],

      //选用图片相关
      loveList: [],

      //gird相关
      row: 1,
      widthWithUP: "",

      //图片说明
      descdialogVisible: false,
      message: "",

      //权限
      powersObj,
      allowLib,
      allowPushChannel,

      //图片前缀
      picPrefix,

      //鼠标右击
      rightMouseTop: 0,
      rightMouseLeft: 0,
      rightMouseFlag: false,

      //图片浏览
      picInfo: {},
      picExif: {},
      imgLoading: false, //图片加载
      dialogVisible: false,
      isUpload: this.$store.state.user.isUpload,
      choosePicMsg: { isLove: false, faceInfo: [], labels: [] },
      picAllListFlag: -1,
      scroll: 0,
      picCha: -1,
      haslovechange: false,
      displayResolution: 0,

      //是否展示人脸
      switechValue: false,
      faceLength: 0,
      imgPicHeight: 0,
      peopleDialogVisible: false,
      faceRuleForm: {
        peopleClass: "",
        region: "",
        name: "",
      },
      faceRules: {
        peopleClass: [
          { required: true, message: "请选择人物分类", trigger: "blur" },
        ],
        region: [{ required: true, message: "请选择地区", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
      },

      faceData: [
        {
          name: "",
          createname: "",
          peopleId: -1,
        },
      ],
      faceid: -1,
      region: [],
      peopleClass: [],
      seeFull: false,
      showSureBtn: true,
      index: -1,
      faceInputFlag: false,
      peopleLoading: false,

      clickFaceDialog: false, //点击人脸查看或修改
      seeOrUpdateFace: 0, //查看或者修改人脸
      nowPeopleInfo: "", //当前人脸信息

      //人脸搜索相关
      facePeopleList: [],
      BigfileId: -1,
      percent: -1,

      showMessageLeft: false,
      showMessageRight: false,

      forestallText: '体验新版',
      isForestall: true
    };
  },
  watch: {
    $route (to, from) {
      let arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
      console.log(arr);
      arr.splice(4, 1)
      console.log(arr);
      // return
      if (sessionStorage.getItem('deleteAltasIndex') >= 0) {
        // let index = this.$route.query.deleteAltasIndex
        let index = sessionStorage.getItem('deleteAltasIndex')
        index = parseInt(index)
        console.log(this.atlasList, index);
        // this.atlasList.splice(index, 1)
        let list = []
        for (let i = 0; i < this.atlasList.length; i++) {
          if (i != index) {
            list.push(this.atlasList[i])
          }
        }
        this.atlasList = list
        console.log(this.atlasList);
        sessionStorage.removeItem('deleteAltasIndex')
      }
    },
    "$store.state.user.bigImage" (newVal, oldVal) {
      console.log(newVal, oldVal);
      this.listPeopleFaceByFileIdAsync(this.BigfileId)
    }
  },
  methods: {
    ...mapActions(["setLoveList"]),
    seeMineAltas () {
      console.log(this.choosePicMsg.atlasId);
      window.open('/seeAltas?id=' + this.choosePicMsg.atlasId)
    },
    clickImageOrAltas (flag) {
      this.searchFlag = flag
      this.centerSearch()
    },
    myformChange (val) {
      console.log(val);
      this.myform.name = val.title;
      this.myform.id = val.id;
    },
    //查看人脸
    seepersonallface (e) {
      if (e.peopleName.indexOf('未命名') !== -1) {
        this.$message.warning('未命名人脸无法查询！')
        return false
      }
      this.dialogVisible = false

      this.$router.push({
        path: '/myLib/seepersonface',
        query: {
          id: e.peopleId,
          title: e.peopleName,
          count: 0
        }
      })
    },

    useNew () {
      if (this.isForestall) {
        this.isForestall = false
        this.forestallText = '体验新版'
      } else {
        this.isForestall = true
        this.forestallText = '切换旧版'
      }
    },

    //人脸操作
    //合并
    mergeFace (scope) {
      this.$confirm("确认合并吗?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      }).then((es) => {
        let val = {
          faceId: this.faceid,
          peopleId: scope.row.id,
          similarity: 0
        };
        this.faceRuleForm.name = scope.row.peopleName;
        this.setPeopleFaceAccessAsync(val);
        this.clickFaceDialog = false;
      });
    },
    //图片操作
    //删除图片
    deletePic (item, index) {
      this.$confirm("确认删除吗？", {
        confirmButtonClass: this.isSimple
          ? "mySimplePriConfirm"
          : "myPriConfirm",
      })
        .then((e) => {
          if (index) {
            // console.log(item);
            this.deletePictureAsync(item.resourceId);
          } else {
            // console.log(this.choosePicMsg)
            this.deletePictureAsync(this.choosePicMsg.id);
          }
        })
        .catch((e) => {
          console.log("取消");
        });
    },
    //删除图片
    async deletePictureAsync (val) {
      let { status, data, message, errors } = await deletePicture(val);
      if (status) {
        this.$message.success("删除成功！即将重新刷新页面！");
        this.dialogVisible = false;
        setTimeout(() => {
          this.centerSearch();
        }, 2000);
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //添加选用图片
    lovePic (item, index) {
      if (index) {
        if (this.picList[index].errortext == "error") {
          this.$message.warning("图片生成失败，无法添加到选用图片!");
          return false;
        }
      } else if (index == 0) {
        if (this.picList[index].errortext == "error") {
          this.$message.warning("图片生成失败，无法添加到选用图片!");
          return false;
        }
      } else {
        if (this.picList[this.choosePicMsg.myId].errortext == "error") {
          this.$message.warning("图片生成失败，无法添加到选用图片!");
          return false;
        }
      }

      // console.log(item,index)
      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString);

      // if (picLoveArray == null) {
      //   for (let i = 0; i < this.picList.length; i++) {
      //     this.picList[i].isLove = false;
      //   }
      // } else {
      //   for (let j = 0; j < picLoveArray.length; j++) {
      //     for (let z = 0; z < this.picList.length; z++) {
      //       if (picLoveArray[j].id === this.picList[z].id) {
      //         this.picList[z].isLove = true;
      //       }
      //     }
      //   }
      // }
      if (index || index == 0) {
        if (!item.isLove) {


          if (this.isForestall) {



            this.loveList.push(item.resourceId);
            this.setLoveList(this.loveList);
            this.picList[index].isLove = true;
            if (!picLoveArray) {
              let pL = [];
              pL.push(item);
              sessionStorage.setItem("picLove", JSON.stringify(pL));
              this.setUserSettingAsync(this.createUid, "picLove", {
                value: item.resourceId,
              });
              this.$message.success("添加成功");
            } else {
              picLoveArray.push(item);
              sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
              let idsInfo = [];
              for (let k = 0; k < picLoveArray.length; k++) {
                idsInfo.push({
                  id: picLoveArray[k].id,
                });
              }
              this.setUserSettingAsync(this.createUid, "picLove", {
                value: idsInfo,
              });
              this.$message.success("添加成功");
            }

            this.$forceUpdate()
          } else {
            this.loveList.push(item.id);
            this.setLoveList(this.loveList);
            this.picList[index].isLove = true;
            if (!picLoveArray) {
              let pL = [];
              pL.push(item);
              sessionStorage.setItem("picLove", JSON.stringify(pL));
              this.setUserSettingAsync(this.createUid, "picLove", {
                value: item.id,
              });
              this.$message.success("添加成功");
            } else {
              picLoveArray.push(item);
              sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
              let idsInfo = [];
              for (let k = 0; k < picLoveArray.length; k++) {
                idsInfo.push({
                  id: picLoveArray[k].id,
                });
              }
              this.setUserSettingAsync(this.createUid, "picLove", {
                value: idsInfo,
              });
              this.$message.success("添加成功");
            }
          }
        } else {
          if (this.isForestall) {
            this.loveList.splice(this.loveList.indexOf(item.resourceId), 1);
            this.setLoveList(this.loveList);

            this.picList[index].isLove = false;

            if (picLoveArray.length === 1) {
              sessionStorage.removeItem("picLove");
              this.setUserSettingAsync(this.createUid, "picLove", {
                value: null,
              });
              this.$message.success("移除成功");
            } else {
              let f;
              for (let i = 0; i < picLoveArray.length; i++) {
                if (item.resourceId === picLoveArray[i].id) {
                  f = i;
                }
              }
              // console.log(picLoveArray)
              picLoveArray.splice(f, 1);
              sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
              let idsInfo = [];
              for (let k = 0; k < picLoveArray.length; k++) {
                idsInfo.push({
                  id: picLoveArray[k].id,
                });
              }
              this.setUserSettingAsync(this.createUid, "picLove", {
                value: idsInfo,
              });
              this.$message.success("移除成功");
            }

            this.$forceUpdate()
          } else {
            this.loveList.splice(this.loveList.indexOf(item.id), 1);
            this.setLoveList(this.loveList);

            this.picList[index].isLove = false;

            if (picLoveArray.length === 1) {
              sessionStorage.removeItem("picLove");
              this.setUserSettingAsync(this.createUid, "picLove", {
                value: null,
              });
              this.$message.success("移除成功");
            } else {
              let f;
              for (let i = 0; i < picLoveArray.length; i++) {
                if (item.id === picLoveArray[i].id) {
                  f = i;
                }
              }
              // console.log(picLoveArray)
              picLoveArray.splice(f, 1);
              sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
              let idsInfo = [];
              for (let k = 0; k < picLoveArray.length; k++) {
                idsInfo.push({
                  id: picLoveArray[k].id,
                });
              }
              this.setUserSettingAsync(this.createUid, "picLove", {
                value: idsInfo,
              });
              this.$message.success("移除成功");
            }
          }
        }
      } else {
        if (!this.choosePicMsg.isLove) {
          this.loveList.push(this.choosePicMsg.id);
          this.setLoveList(this.loveList);
          this.choosePicMsg.isLove = true;

          this.haslovechange = true;

          if (!picLoveArray) {
            let pL = [];
            pL.push(this.choosePicMsg);
            sessionStorage.setItem("picLove", JSON.stringify(pL));
            this.setUserSettingAsync(this.createUid, "picLove", {
              value: this.choosePicMsg.id,
            });
            this.$message.success("添加成功");
          } else {
            picLoveArray.push({ id: this.choosePicMsg.id });
            sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
            let idsInfo = [];
            for (let k = 0; k < picLoveArray.length; k++) {
              idsInfo.push({
                id: picLoveArray[k].id,
              });
            }
            this.setUserSettingAsync(this.createUid, "picLove", {
              value: idsInfo,
            });
            this.$message.success("添加成功");
          }
        } else {
          this.loveList.splice(this.loveList.indexOf(this.choosePicMsg.id), 1);
          this.setLoveList(this.loveList);

          this.choosePicMsg.isLove = false;

          this.haslovechange = false;

          if (picLoveArray.length === 1) {
            sessionStorage.removeItem("picLove");
            this.setUserSettingAsync(this.createUid, "picLove", {
              value: null,
            });
            this.$message.success("移除成功");
          } else {
            let f;
            for (let i = 0; i < picLoveArray.length; i++) {
              if (this.choosePicMsg.id === picLoveArray[i].id) {
                f = i;
              }
            }
            // console.log(picLoveArray)
            picLoveArray.splice(f, 1);
            let idsInfo = [];
            for (let k = 0; k < picLoveArray.length; k++) {
              idsInfo.push({
                id: picLoveArray[k].id,
              });
            }
            sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
            this.setUserSettingAsync(this.createUid, "picLove", {
              value: idsInfo,
            });
            this.$message.success("移除成功");
          }
        }
      }

      // console.log(picLoveArray,item)
    },

    //修改图片说明
    openChangeDesc (val) {
      // console.log(val)
      this.message = val;
      this.descdialogVisible = true;
    },
    deschandleClose () {
      this.descdialogVisible = false;
    },
    changeDesc (val) {
      console.log(val);
      try {
        if (val.resourceId) {
          val.id = val.resourceId
        }
      } catch (error) {

      }
      this.updatePictureAsync(val);
      this.descdialogVisible = false;
    },
    //修改图片说明
    async updatePictureAsync (val) {
      let { status, data, message, errors } = await updatePicture(val);
      if (status) {
        this.$message.success("修改成功！");
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //查看人脸
    seeFace () {
      this.switechValue = !this.switechValue;
      this.$refs.imgPic.style.left = "";
      this.$refs.imgPic.style.top = "";
      this.picTimes = 1;
      this.picDeg = 0;
      this.$refs.imgPic.style.transform =
        "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
    },
    handleClose () {
      this.faceRuleForm = {};
      this.faceData = {};
      this.faceInputFlag = false;
      this.peopleDialogVisible = false;
      this.clickFaceDialog = false
    },
    beSure (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let val = {
            peopleClass: this.faceRuleForm.peopleClass,
            region: this.faceRuleForm.region,
            peopleName: this.faceRuleForm.name,
          };
          this.peopleLoading = true;
          this.addPeopleAsync(val);
          this.clickFaceDialog = false
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async addPeopleAsync (val) {
      let { status, data, message, errors } = await addPeople(val);
      if (status) {
        let value = {
          faceId: this.faceid,
          peopleId: data.id,
          similarity: 0
        };
        // console.log(value);
        this.setPeopleFaceAccessAsync(value);
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
      this.peopleLoading = false;
    },
    async setPeopleFaceAccessAsync (val) {
      let { status, data, message, errors } = await setPeopleFaceAccess(val);
      if (status) {
        this.$message.success(message);
        this.peopleDialogVisible = false;
        // console.log(1);
        this.choosePicMsg.faceInfo[
          this.index
        ].peopleName = this.faceRuleForm.name;
        this.faceRuleForm = {};
        this.faceInputFlag = false;
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
        console.log(2);
      }
      this.peopleLoading = false;
    },
    clickFaceDialogHandleClose () {
      this.clickFaceDialog = false;
      this.seeOrUpdateFace = 0;
    },
    async clickFaceDialogFun () {
      //确认修改或者查看人脸
      if (this.seeOrUpdateFace == 1) {
        this.faceid = this.nowPeopleInfo.faceId;
        this.index = this.nowPeopleInfo.index;
        if (this.nowPeopleInfo.peopleName == "未设置") {
          this.peopleDialogVisible = true;
          this.getPeopleConstantAsync();
        } else {
          this.peopleDialogVisible = true;
          this.getPeopleConstantAsync();
        }
      } else if (this.seeOrUpdateFace == 2) {
        // setTimeout(() => {
        this.$refs.seePeopleFace.getInfo(this.nowPeopleInfo);
        // }, 200);
      } else {
        this.$message.warning("请选择修改或查看！");
      }
    },
    async getPeopleConstantAsync () {
      let { status, data, message } = await getPeopleConstant();
      this.region = data.region;
      this.peopleClass = data.peopleClass;
    },
    getFaceId (num, item, index) {
      // this.clickFaceDialog = true;
      this.nowPeopleInfo = item;
      this.nowPeopleInfo.index = index;
      this.seeOrUpdateFace = num
      this.clickFaceDialogFun()
    },
    myInput (item) {
      let val;
      if (item.length >= 1) {
        this.faceInputFlag = true;
        val = {
          name: item,
          fuzzySearch: true,
        };
        this.listFacePeopleAsync(val);
      } else {
        this.faceInputFlag = false;
      }
    },
    async listFacePeopleAsync (val) {
      let { status, data, message } = await listPeople(val);
      if (status) {
        this.faceData = data;
        for (let i = 0; i < data.length; i++) {
          data[i].peopleLogo = picPrefix + data[i].peopleLogo;

          if (data[i].peopleName === this.faceRuleForm.name) {
            this.showSureBtn = false;
          } else {
            this.showSureBtn = true;
          }
        }
        if (data.length == 0) {
          this.showSureBtn = true;
        }
      }
    },

    //图片浏览相关
    openDialog (i, e) {
      console.log(e);
      // console.log(this.switechValue);
      this.switechValue = false;
      // console.log(this.switechValue);
      this.dialogVisible = true;
      this.choosePicMsg = { isLove: false, faceInfo: [] };

      this.choosePicMsg.fileId = e.fileId;
      // e.labels=['风景','运动员','环境','劳作','亲子活动','开会','抗洪抢险','剪裁']
      this.choosePicMsg.id = this.isForestall ? e.resourceId : e.id;
      this.choosePicMsg.desc = e.desc;
      this.choosePicMsg.downloadCount = e.downloadCount;
      this.choosePicMsg.pushCount = e.pushCount;
      this.choosePicMsg.shareCount = e.shareCount;
      this.choosePicMsg.atlasId = e.atlasId;
      this.choosePicMsg.errortext = "";
      if (e.errortext) {
        this.choosePicMsg.errortext = e.errortext;
      }
      this.choosePicMsg.src = e.srcW1080;
      this.choosePicMsg.srcW1080 = e.srcW1080;
      if (e.createUserInfo) {
        this.choosePicMsg.createUserName = e.createUserInfo.name;
      } else {
        this.choosePicMsg.createUserName = "暂无";
      }
      if (e.atlasInfo) {
        this.choosePicMsg.altasName = e.atlasInfo.name;
      } else {
        this.choosePicMsg.altasName = "暂无";
      }
      if (this.isForestall) {
        this.choosePicMsg.atlasCreateUserName = e.atlasCreateUserName || '暂无'
        this.choosePicMsg.atlasName = e.atlasName || '暂无'
        // this.choosePicMsg.atlasName = e.atlasInfo.name || '暂无'
      }
      this.atlasName = e.atlasInfo.name || '暂无'

      this.choosePicMsg.myId = i;
      this.choosePicMsg.labels = this.isForestall ? e.tags.split(',') : e.labels;

      this.picAllListFlag = i;

      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString);

      this.choosePicMsg.isLove = false;
      this.haslovechange = false;
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true;
            this.haslovechange = true;
          }
        }
      }


      // let faceInfo = await listPeopleFaceByFileId({ fileId: this.choosePicMsg.fileId })
      // let faceCoord = faceInfo.data
      this.getLibInfo(e.libId)
      this.getPicInfo(e);

      this.$nextTick(() => {
        this.clearLargeAndSmall();
        this.beSurePic(i, 10);
      });

      this.BigfileId = e.fileId;
      setTimeout(() => {
        this.imgPicHeight = this.$refs.imgPic.clientHeight || 279;
        this.listPeopleFaceByFileIdAsync(e.fileId);
      }, 1000);
    },
    async getLibInfo (id) {
      let { status, data } = await getLib(id);
      if (status) {
        this.choosePicMsg.libName = data.name
      } else {
        this.choosePicMsg.libName = '暂无'
      }
    },
    async picListClick (e, i) {
      this.clearLargeAndSmall();
      this.choosePicMsg.fileId = e.fileId;
      this.choosePicMsg.id = this.isForestall ? e.resourceId : e.id;
      this.choosePicMsg.labels = this.isForestall ? e.tags.split(',') : e.labels;
      this.choosePicMsg.desc = e.desc;
      this.choosePicMsg.downloadCount = e.downloadCount;
      this.choosePicMsg.pushCount = e.pushCount;
      this.choosePicMsg.shareCount = e.shareCount;
      this.choosePicMsg.errortext = "";
      if (e.errortext) {
        this.choosePicMsg.errortext = e.errortext;
      }
      this.choosePicMsg.src = e.srcW1080;
      this.choosePicMsg.srcW1080 = e.srcW1080;
      if (e.createUserInfo) {
        this.choosePicMsg.createUserName = e.createUserInfo.name;
      } else {
        this.choosePicMsg.createUserName = "暂无";
      }
      if (e.atlasInfo) {
        this.choosePicMsg.altasName = e.atlasInfo.name;
      } else {
        this.choosePicMsg.altasName = "暂无";
      }

      if (this.isForestall) {
        this.choosePicMsg.atlasCreateUserName = e.atlasCreateUserName || '暂无'
        this.choosePicMsg.atlasName = e.atlasName || '暂无'
      }
      this.choosePicMsg.faceInfo = [];
      this.choosePicMsg.myId = i;
      this.picAllListFlag = i;

      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString);

      this.choosePicMsg.isLove = false;
      this.haslovechange = false;
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true;
            this.haslovechange = true;
          }
        }
      }

      this.getPicInfo(e);
    },

    seeBigSmall () {
      // this.switechValue = false
      // this.seeFull = !this.seeFull
      this.$refs.imgPic.style.left = "";
      this.$refs.imgPic.style.top = "";
      this.picTimes = 1;
      this.picDeg = 0;
      this.$refs.imgPic.style.transform =
        "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
      this.$store.commit("SET_BigImage", !this.$store.state.user.bigImage);
      if (this.$store.state.user.bigImage) {
        fullScreen(this.$refs.imgBj);
        this.seeFull = true;
      } else {
        exitFullscreen();
        this.seeFull = false;
      }
    },

    //图片浏览中大的箭头 左边
    async bigLeft () {
      if (this.choosePicMsg.myId === 0) {
        if (!this.showMessageLeft) {
          this.showMessageLeft = true
          setTimeout(() => {
            this.showMessageLeft = false
          }, 1500);
        }
        return;
      }
      // if(this.choosePicMsg.id === this.picList.length - 1){
      //   return
      // }
      this.clearLargeAndSmall();
      // this.choosePicMsg.libName = ''
      this.getLibInfo(this.picList[
        this.choosePicMsg.myId - 1
      ].libId)
      this.choosePicMsg.errortext = "";
      if (this.picList[this.choosePicMsg.myId - 1].errortext) {
        this.choosePicMsg.errortext = this.picList[
          this.choosePicMsg.myId - 1
        ].errortext;
      }
      this.choosePicMsg.fileId = this.picList[
        this.choosePicMsg.myId - 1
      ].fileId;
      this.choosePicMsg.atlasId = this.picList[
        this.choosePicMsg.myId - 1
      ].atlasId;
      this.choosePicMsg.labels = this.isForestall ? this.picList[
        this.choosePicMsg.myId - 1
      ].tags.split(',') : this.picList[
        this.choosePicMsg.myId - 1
      ].labels;
      this.choosePicMsg.src = this.picList[this.choosePicMsg.myId - 1].srcW1080;
      this.choosePicMsg.srcW1080 = this.picList[
        this.choosePicMsg.myId - 1
      ].srcW1080;
      this.choosePicMsg.desc = this.picList[this.choosePicMsg.myId - 1].desc;
      this.choosePicMsg.downloadCount = this.picList[
        this.choosePicMsg.myId - 1
      ].downloadCount;
      this.choosePicMsg.pushCount = this.picList[
        this.choosePicMsg.myId - 1
      ].pushCount;
      this.choosePicMsg.shareCount = this.picList[
        this.choosePicMsg.myId - 1
      ].shareCount;
      this.choosePicMsg.id = this.isForestall ? this.picList[this.choosePicMsg.myId - 1].resourceId : this.picList[this.choosePicMsg.myId - 1].id;
      if (this.picList[this.choosePicMsg.myId - 1].createUserInfo) {
        this.choosePicMsg.createUserName = this.picList[
          this.choosePicMsg.myId - 1
        ].createUserInfo.name;
      } else {
        this.choosePicMsg.createUserName = "暂无";
      }
      if (this.picList[this.choosePicMsg.myId - 1].atlasInfo) {
        this.choosePicMsg.altasName = this.picList[
          this.choosePicMsg.myId - 1
        ].atlasInfo.name;
      } else {
        this.choosePicMsg.altasName = "暂无";
      }
      if (this.isForestall) {
        this.choosePicMsg.atlasCreateUserName = this.picList[
          this.choosePicMsg.myId - 1
        ].atlasCreateUserName || '暂无'
        this.choosePicMsg.atlasName = this.picList[
          this.choosePicMsg.myId - 1
        ].atlasName || '暂无'
      }
      this.choosePicMsg.faceInfo = [];
      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString);

      this.choosePicMsg.isLove = false;
      this.haslovechange = false;
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true;
            this.haslovechange = true;
          }
        }
      }

      this.getPicInfo(this.picList[this.choosePicMsg.myId - 1]);

      this.choosePicMsg.myId = this.choosePicMsg.myId - 1;
      // console.log(this.choosePicMsg)
      this.picAllListFlag = this.choosePicMsg.myId;
      if (this.choosePicMsg.myId < 10) {
        this.scroll = 0;
        this.picCha = -1;
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.scroll = this.scroll + 3 * this.choosePicMsg.myId;
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }

      this.BigfileId = this.choosePicMsg.fileId;
      this.listPeopleFaceByFileIdAsync(this.choosePicMsg.fileId);
    },
    //图片浏览中大的箭头 右边
    async bigRight () {
      if (this.choosePicMsg.myId === this.picList.length - 1) {
        if (!this.showMessageRight) {
          this.showMessageRight = true
          setTimeout(() => {
            this.showMessageRight = false
          }, 1500);
        }
        return;
      }
      // this.picListClick(this.picList[this.choosePicMsg.id + 1],this.choosePicMsg.id + 1)
      this.clearLargeAndSmall();
      // this.choosePicMsg.libName = ''
      this.getLibInfo(this.picList[
        this.choosePicMsg.myId + 1
      ].libId)
      this.choosePicMsg.errortext = "";
      if (this.picList[this.choosePicMsg.myId + 1].errortext) {
        this.choosePicMsg.errortext = this.picList[
          this.choosePicMsg.myId + 1
        ].errortext;
      }
      this.choosePicMsg.fileId = this.picList[
        this.choosePicMsg.myId + 1
      ].fileId;
      this.choosePicMsg.atlasId = this.picList[
        this.choosePicMsg.myId + 1
      ].atlasId;
      this.choosePicMsg.labels = this.isForestall ? this.picList[
        this.choosePicMsg.myId + 1
      ].tags.split(',') : this.picList[
        this.choosePicMsg.myId + 1
      ].labels;
      this.choosePicMsg.src = this.picList[this.choosePicMsg.myId + 1].srcW1080;
      this.choosePicMsg.srcW1080 = this.picList[
        this.choosePicMsg.myId + 1
      ].srcW1080;
      this.choosePicMsg.desc = this.picList[this.choosePicMsg.myId + 1].desc;
      this.choosePicMsg.downloadCount = this.picList[
        this.choosePicMsg.myId + 1
      ].downloadCount;
      this.choosePicMsg.pushCount = this.picList[
        this.choosePicMsg.myId + 1
      ].pushCount;
      this.choosePicMsg.shareCount = this.picList[
        this.choosePicMsg.myId + 1
      ].shareCount;
      this.choosePicMsg.id = this.isForestall ? this.picList[this.choosePicMsg.myId + 1].resourceId : this.picList[this.choosePicMsg.myId + 1].id;
      if (this.picList[this.choosePicMsg.myId + 1].createUserInfo) {
        this.choosePicMsg.createUserName = this.picList[
          this.choosePicMsg.myId + 1
        ].createUserInfo.name;
      } else {
        this.choosePicMsg.createUserName = "暂无";
      }
      if (this.picList[this.choosePicMsg.myId + 1].atlasInfo) {
        this.choosePicMsg.altasName = this.picList[
          this.choosePicMsg.myId + 1
        ].atlasInfo.name;
      } else {
        this.choosePicMsg.altasName = "暂无";
      }

      if (this.isForestall) {
        this.choosePicMsg.atlasCreateUserName = this.picList[
          this.choosePicMsg.myId + 1
        ].atlasCreateUserName || '暂无'
        this.choosePicMsg.atlasName = this.picList[
          this.choosePicMsg.myId + 1
        ].atlasName || '暂无'
      }
      this.choosePicMsg.faceInfo = [];
      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString);

      this.choosePicMsg.isLove = false;
      this.haslovechange = false;
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true;
            this.haslovechange = true;
          }
        }
      }

      this.getPicInfo(this.picList[this.choosePicMsg.myId + 1]);

      this.choosePicMsg.myId = this.choosePicMsg.myId + 1;

      this.picAllListFlag = this.choosePicMsg.myId;
      // console.log(this.choosePicMsg)
      if (this.choosePicMsg.myId > 10) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        // console.log(this.scroll)
        // console.log(this.choosePicMsg.myId)
        if (this.scroll === 0) {
          this.scroll = this.choosePicMsg.myId * -70;
        } else {
          if (this.choosePicMsg.myId > 50) {
            this.scroll = this.scroll - 2 * this.choosePicMsg.myId;
          } else {
            this.scroll = this.scroll - 3 * this.choosePicMsg.myId;
          }
        }
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 80;
          setTimeout(() => {
            this.picCha = this.scroll;
          }, 1000);
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
      this.BigfileId = this.choosePicMsg.fileId;
      this.listPeopleFaceByFileIdAsync(this.choosePicMsg.fileId);
    },

    //图片浏览小的箭头 右边
    smallRight () {
      let picalllistwidth = this.$refs.picalllist.offsetWidth;
      let piclistwidth = this.$refs.piclist.offsetWidth;
      this.scroll = this.scroll - 300;
      if (this.scroll < piclistwidth - picalllistwidth) {
        this.scroll = piclistwidth - picalllistwidth - 70;
        this.picCha = this.scroll;
        // console.log(this.scroll)
      }

      this.$refs.picalllist.style.transform =
        "translateX(" + this.scroll + "px)";

      // console.log(this.scroll)
    },
    //图片浏览小的箭头 左边
    smallLeft () {
      // let picalllistwidth = this.$refs.picalllist.offsetWidth
      // let piclistwidth = this.$refs.piclist.offsetWidth
      this.scroll = this.scroll + 300;
      if (this.scroll > 0) {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + "px)";
        this.scroll = 0;
      } else {
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }

      // console.log(this.scroll)
    },
    //图片放大
    picLarge () {
      this.picTimes += 1.5;
      if (this.picTimes < 6) {
        this.$refs.imgPic.style.transform =
          "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
      } else {
        this.picTimes = 6;
        this.$refs.imgPic.style.transform =
          "scale(6) rotateZ(" + this.picDeg + "deg)";
      }
    },
    //图片缩小
    picSmall () {
      this.picTimes -= 1.5;
      if (this.picTimes > 1) {
        this.$refs.imgPic.style.transform =
          "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
      } else {
        this.picTimes = 1;
        this.$refs.imgPic.style.transform =
          "scale(1) rotateZ(" + this.picDeg + "deg)";
      }
    },

    //图片旋转
    picRotateLeft () {
      this.switechValue = false;
      this.picDeg -= 90;
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform =
        "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
    },
    //图片旋转
    picRotateRight () {
      this.switechValue = false;
      this.picDeg += 90;
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform =
        "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
    },
    //清除放大缩小效果
    clearLargeAndSmall () {
      this.$refs.imgPic.style.left = "";
      this.$refs.imgPic.style.top = "";
      this.picTimes = 1;
      this.picDeg = 0;
      this.$refs.imgPic.style.transform =
        "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
    },
    //判断选中的图片在什么位置
    beSurePic (i, num) {
      if (i > num) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        this.scroll = i * -80;
        // console.log(piclistwidth - picalllistwidth)
        // console.log(this.scroll)
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 70;
          this.picCha = this.scroll;
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + ")";
        this.scroll = 0;
      }
    },
    //获取图片信息
    getPicInfo (e) {
      console.log(e);
      if (this.isForestall) {
        this.picInfo.picH = e.picH || "1920";
        this.picInfo.picW = e.picW || "1080";
        this.picInfo.format =
          e.ext || "jpg";
        this.picInfo.createAt = formatConversion(
          e.createAt.toString()
        ).substring(0, 10);
        this.picInfo.fileSize =
          (e.fileSize / 1024 / 1024).toFixed(2) || "暂无";


        if (e.fileCreateAt) {
          this.picExif.CreateAtMy = '';
          this.picExif.CreateAtMy = formatConversion(
            e.createAt.toString()
          ).substring(0, 10);
        } else {
          this.picExif.CreateAtMy = null;
        }
        // this.BigfileId = e.resourceId;
        // this.listPeopleFaceByFileIdAsync(e.resourceId);
      } else {
        this.picInfo.picH = e.fileInfo.picH || "1920";
        this.picInfo.picW = e.fileInfo.picW || "1080";
        this.picInfo.format =
          e.fileInfo.savepath.substring(e.fileInfo.savepath.length - 3) || "jpg";
        this.picInfo.createAt = formatConversion(
          e.fileInfo.createAt.toString()
        ).substring(0, 10);
        this.picInfo.fileSize =
          (e.fileInfo.fileSize / 1024 / 1024).toFixed(2) || "暂无";

        if (e.exif) {
          this.picExif = e.exif;
          if (e.exif.CreateAt) {
            this.picExif.CreateAtMy = formatConversion(
              this.picExif.CreateAt.toString()
            ).substring(0, 10);
          } else {
            this.picExif.CreateAtMy = null;
          }
        }

      }
      this.BigfileId = e.fileId;
      this.listPeopleFaceByFileIdAsync(e.fileId);
    },
    async listPeopleFaceByFileIdAsync (fileId) {
      console.log(this.$store.state.user.bigImage);
      if (this.$store.state.user.bigImage) {
        this.percent = this.picInfo.picH / window.screen.height;
      } else {
        this.percent = this.picInfo.picH / this.imgPicHeight;
      }
      let { data, message, status } = await listPeopleFaceByFileId({
        fileId: fileId,
      });
      if (status) {
        this.choosePicMsg.faceInfo = [];
        this.faceLength = data.length;
        this.$forceUpdate();
        for (let i = 0; i < data.length; i++) {
          this.faceArr = {};
          let coordArr = data[i].coord.split(",");
          coordArr[0] = Math.round(
            parseFloat(coordArr[0]) * (this.picInfo.picH / this.percent)
          );
          coordArr[1] = Math.round(
            parseFloat(coordArr[1]) * (this.picInfo.picW / this.percent)
          );
          coordArr[2] = Math.round(
            parseFloat(coordArr[2]) * (this.picInfo.picH / this.percent)
          );
          coordArr[3] = Math.round(
            parseFloat(coordArr[3]) * (this.picInfo.picW / this.percent)
          );
          this.faceArr.width = coordArr[1] - coordArr[3];
          this.faceArr.height = coordArr[2] - coordArr[0];
          this.faceArr.top = Math.round(
            coordArr[0] - this.picInfo.picH / this.percent / 2
          );
          this.faceArr.left = Math.round(
            coordArr[3] - this.picInfo.picW / this.percent / 2
          );
          this.faceArr.faceId = data[i].id;
          this.faceArr.peopleId = data[i].peopleId;
          if (data[i].peopleInfo === null) {
            let sexArray = ['男', '女']
            if (data[i].sex !== -1 && data[i].age !== -1) {
              this.faceArr.peopleName = `未命名（${data[i].sex !== -1 ? sexArray[data[i].sex] : ''} ${data[i].age !== -1 ? data[i].age + '岁' : ''}）`
            } else {
              this.faceArr.peopleName = `未命名`
            }
          } else {
            let sexArray = ['男', '女']
            if (data[i].sex !== -1 && data[i].age !== -1) {
              this.faceArr.peopleName = `${data[i].peopleInfo.peopleName}（${data[i].sex !== -1 ? sexArray[data[i].sex] : ''} ${data[i].age !== -1 ? data[i].age + '岁' : ''}）`
            } else {
              this.faceArr.peopleName = `${data[i].peopleInfo.peopleName}`
            }
          }
          this.choosePicMsg.faceInfo.push(this.faceArr);
          this.$forceUpdate();
        }
      }
    },

    //清除日期
    cleartime () {
      this.time = ''
      this.timeStart = "";
      this.timeEnd = "";
      this.formaTimeStart = "";
      this.formaTimeEnd = "";
      this.isTime = false
      this.sort = {
        id: 0,
        name: "按时间从近到远排列",
      }
      this.centerSearch()
    },
    cleartaketime () {
      this.takeTime = ''
      this.takeTimeStart = "";
      this.takeTimeEnd = "";
      this.timeTakeStart = "";
      this.timeTakeEnd = "";
      this.isTakeTime = false
      this.sort = {
        id: 0,
        name: "按时间从近到远排列",
      }
      this.centerSearch()
    },

    //筛选
    screen (num, e, i) {
      switch (num) {
        case 1:
          this.library = e;
          this.libFlag = i;
          this.screenisLibrary = false;
          break;
        case 2:
          this.theme = e;
          this.themeFlag = i;
          this.isTheme = false;
          break;
        case 3:
          this.environment = e;
          this.environmentFlag = i;
          this.isEnvironment = false;
          break;
        case 4:
          this.contributors = e;
          this.contributorFlag = i;
          this.isContributors = false;
          break;
        case 5:
          this.peopleFace = e;
          this.peopleFaceFlag = i;
          this.isPeopleFace = false;
          break;
        case 6:
          if (!this.timeStart) {
            this.$message.warning("请填写开始时间！");
            return false;
          }
          if (!this.timeEnd) {
            this.$message.warning("请填写结束时间！");
            return false;
          }
          this.time = true;
          this.formaTimeStart = formatConversion(
            (this.timeStart / 1000).toString()
          ).substring(0, 10);
          this.formaTimeEnd = formatConversion(
            (this.timeEnd / 1000).toString()
          ).substring(0, 10);
          this.isTime = false;
          break;
        case 8:
          if (!this.timeTakeStart) {
            this.$message.warning("请填写开始时间！");
            return false;
          }
          if (!this.timeTakeEnd) {
            this.$message.warning("请填写结束时间！");
            return false;
          }
          this.takeTime = true;
          this.takeTimeStart = formatConversion(
            (this.timeTakeStart / 1000).toString()
          ).substring(0, 10);
          this.takeTimeEnd = formatConversion(
            (this.timeTakeEnd / 1000).toString()
          ).substring(0, 10);
          this.isTakeTime = false;
          break;
        case 7:
          this.sort = e;
          this.sortFlag = i;
          this.isSort = false;
          break;
        default:
          break;
      }
      if (e) {
        if (e.id == -1) {
          this.peopleFaceSearch = ""
          this.searchPeo()
        }
      }
      this.centerSearch()
    },
    //打开筛选列表
    openList (i) {
      switch (i) {
        case 1:
          this.isLibrary = !this.isLibrary;
          this.isTheme = false;
          this.isEnvironment = false;
          this.isContributors = false;
          this.isPeopleFace = false;
          this.isTime = false;
          this.isSort = false;
          this.isTakeTime = false;
          break;
        case 2:
          this.isLibrary = false;
          this.isTheme = !this.isTheme;
          this.isEnvironment = false;
          this.isContributors = false;
          this.isPeopleFace = false;
          this.isTime = false;
          this.isSort = false;
          this.isTakeTime = false;
          break;
        case 3:
          this.isLibrary = false;
          this.isTheme = false;
          this.isEnvironment = !this.isEnvironment;
          this.isContributors = false;
          this.isPeopleFace = false;
          this.isTime = false;
          this.isSort = false;
          this.isTakeTime = false;
          break;
        case 4:
          this.isLibrary = false;
          this.isTheme = false;
          this.isEnvironment = false;
          this.isContributors = !this.isContributors;
          this.isPeopleFace = false;
          this.isTime = false;
          this.isSort = false;
          this.isTakeTime = false;
          break;
        case 5:
          this.isLibrary = false;
          this.isTheme = false;
          this.isEnvironment = false;
          this.isContributors = false;
          this.isPeopleFace = !this.isPeopleFace;
          this.isTime = false;
          this.isSort = false;
          this.isTakeTime = false;
          break;
        case 6:
          this.isLibrary = false;
          this.isTheme = false;
          this.isEnvironment = false;
          this.isContributors = false;
          this.isPeopleFace = false;
          this.isTime = !this.isTime;
          this.isSort = false;
          this.isTakeTime = false;
          break;
        case 7:
          this.isLibrary = false;
          this.isTheme = false;
          this.isEnvironment = false;
          this.isContributors = false;
          this.isPeopleFace = false;
          this.isTime = false;
          this.isTakeTime = false;
          this.isSort = !this.isSort;
          break;
        case 8:
          this.isLibrary = false;
          this.isTheme = false;
          this.isEnvironment = false;
          this.isContributors = false;
          this.isPeopleFace = false;
          this.isTime = false;
          this.isSort = false;
          this.isTakeTime = !this.isTakeTime;
          break;
        default:
          this.isLibrary = false;
          this.isTheme = false;
          this.isEnvironment = false;
          this.isContributors = false;
          this.isPeopleFace = false;
          this.isTime = false;
          this.isSort = false;
          this.isTakeTime = false;
          break;
      }
    },
    //清空输入内容
    clearKeyWord () {
      this.keyword = "";
    },
    //检索
    centerSearch () {
      // if (
      //   (!this.keyword &&
      //     !this.library &&
      //     !this.theme &&
      //     !this.environment &&
      //     !this.contributors &&
      //     !this.peopleFace &&
      //     !this.formaTimeStart) &&
      //   this.searchFlag
      // ) {
      //   this.$message("请选择或填写需要筛选的信息！");
      //   return;
      // }

      this.isPic = this.searchFlag;
      this.pagePic = 0;

      let labels = [];
      if (!this.environment && !this.theme) {
        labels = null;
      } else {
        if (this.environment) {
          if (this.environment.id !== -1) {
            labels.push(this.environment.id);
          }
        }
        if (this.theme) {
          if (this.theme.id !== -1) {
            labels.push(this.theme.id);
          }
        }

        labels = labels.join(",");
      }
      let params = {
        createUid: this.contributors.id !== -1 ? this.contributors.id : 0,
        // keyword: '1',
        keyword: this.keyword,
        libId: this.library.id !== -1 ? this.library.id : 0,
        timeStart: this.timeStart ? this.timeStart / 1000 : '',
        timeEnd: this.timeEnd ? this.timeEnd / 1000 + 86399 : '',
        takeStart: this.timeTakeStart ? this.timeTakeStart / 1000 : '',
        takeEnd: this.timeTakeEnd ? this.timeTakeEnd / 1000 + 86399 : '',
        page: this.pagePic,
        pageSize: this.pageSizePic,
        orderByTime: this.sort.id !== -1 ? this.sort.id : 0,
        status: 1,
        peopleId: this.peopleFace.id !== -1 ? this.peopleFace.id : 0,
        peopleName: this.peopleFace.id !== -1 ? this.peopleFace.name : '',
        labels: labels
      };
      this.searchLoading = true;
      this.picList = [];
      // this.searchPictureAsync(params);
      this.listAtlasPicturesAsync()
    },

    //图集操作
    //图集推送按钮
    pushClick (i) {
      this.atlasId = i.id;
      this.listAllowPushChannelAsync();
    },
    //推送选择
    choosePush (i, t, name, id) {
      this.pushIndex = i;
      this.template = t;
      this.pushChannelId = id;
      this.pushPic(name);
    },
    pushPic (name) {
      if (this.template === "picture-website") {
        this.pushdialogVisible = false;
        this.$router.push({
          path: "/shareAndPush/push/show",
          query: {
            isSavePic: true,
            name: name,
            isDrawer: false,
            id: this.atlasId,
            pushChannelId: this.pushChannelId,
          },
        });
      } else if (this.template === "routersoft-qms") {
        this.pushdialogVisible = false;
        this.$router.push({
          path: "/shareAndPush/push/qms",
          query: {
            isSavePic: true,
            name: name,
            isDrawer: false,
            id: this.atlasId,
            pushChannelId: this.pushChannelId,
          },
        });
      } else if (
        this.template === "routersoft-rmt" ||
        this.template === "routersoft-mcp"
      ) {
        this.pushdialogVisible = false;
        this.$router.push({
          path: "/shareAndPush/push/mcp",
          query: {
            isSavePic: true,
            name: name,
            isDrawer: false,
            id: this.atlasId,
            pushChannelId: this.pushChannelId,
          },
        });
      } else if (
        this.template === "picture-need" ||
        this.template === "system-picture-need"
      ) {
        this.mydialogVisible = true;
        this.pushdialogVisible = false;
        //获取图片邀约
        this.listPictureNeedAsync();
      } else if (this.template === "picture-user") {
        this.dialogVisibleUser = true;
        this.listUserPushAsync({ userType: 0 });
      } else if (this.template === "eastnet-mc") {
        this.dfdialogVisible = true;
      }
    },
    downLoadPicAtlas (e) {
      //下载图集按钮
      this.$confirm("确定下载图集？", {
        confirmButtonClass: this.isSimple
          ? "mySimplePriConfirm"
          : "myPriConfirm",
      }).then(() => {
        this.getAtlasSonIdsAsync(e.id, "download", e);
      });
    },
    //图集分享
    sharePicAtlas (e) {
      this.$confirm("确定分享图集？", {
        confirmButtonClass: this.isSimple
          ? "mySimplePriConfirm"
          : "myPriConfirm",
      }).then(() => {
        this.shareAtlasId = e.id;
        this.dialogVisibleWork = true;
        this.listWorkgroupAsync();
      });
    },
    //分享到工作圈
    submitWork (form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          let { status, data, message } = await getAtlasSonIds(
            this.shareAtlasId
          );
          let picid = data.toString();
          let choosePicMsg = {
            createUid: this.createUid,
            packageType: "share",
            pictureCount: data.length,
            pictureIds: picid,
            targetUid: 0,
            targetWorkgroupId: this.workForm.work,
            title: this.workForm.name,
            shareConfig: JSON.stringify({
              pushChannelId: "",
              note: this.workForm.note,
            }),
          };

          this.addPicturePackageAsync(choosePicMsg);

          this.dialogVisibleWork = false;
          setTimeout(() => {
            this.$router.push("/shareAndPush/myShare");
          }, 1500);
          this.$nextTick(() => {
            this.shareFlag = false;
          });
          this.workForm = {};
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //工作圈筛选
    selectWork (query) {
      let dataExa;
      if (query !== "") {
        dataExa = { page: 0, pageSize: 20, keyword: query };
        this.listWorkgroupAsync(dataExa);
      } else {
        dataExa = { page: 0, pageSize: 20 };
        this.listWorkgroupAsync(dataExa);
      }
    },

    //获取工作圈列表
    async listWorkgroupAsync (val) {
      let { status, data, message, errors } = await listWorkgroup(val);
      if (status) {
        this.workList = data;
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //推送渠道
    handleClosePush () {
      this.pushdialogVisible = false;
    },
    //推送到个人
    handleCloseUser () {
      this.dialogVisibleUser = false;
    },

    //推送到图片邀约
    handleClosePic () {
      this.mydialogVisible = false;
      // this.clearData()
    },
    //东方网融媒体平台关闭
    dfhandleClosePic () {
      this.$refs["dfmyform"].resetFields();
      this.dfdialogVisible = false;
    },

    //图片邀约推送渠道
    quitPic () {
      this.mydialogVisible = false;
      // this.clearData()
    },

    //分享
    handleCloseWork () {
      this.$refs["workForm"].resetFields();
      this.dialogVisibleWork = false;
    },

    //东方推送
    dfsubmitPic (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.userGetAtlasSonIdsAsync(this.atlasId, "push", this.dfmyform);
          this.pushIndex = 0;
          this.dfdialogVisible = false;
          this.$router.push("/shareAndPush/myPush");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    submitPic (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          // console.log(1)
          this.getAtlasSonIdsAsync(this.atlasId, "push");
          this.pushIndex = 0;
          setTimeout(() => {
            this.$router.push("/shareAndPush/myPush");
          }, 1000);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    submitUser (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.userGetAtlasSonIdsAsync(this.atlasId, "push", this.userForm);
          this.dialogVisibleUser = false;
          this.handleClosePush = false;
          this.pushIndex = 0;

          this.$nextTick(() => {
            this.$router.push("/shareAndPush/myPush");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //用户名筛选
    selectUser (query) {
      let dataExa;
      if (query !== "") {
        dataExa = { userType: 0, keyword: query };
        this.listUserPushAsync(dataExa);
      } else {
        dataExa = { userType: 0 };
        this.listUserPushAsync(dataExa);
      }
    },

    //获取用户列表
    async listUserPushAsync (val) {
      let { status, data, message, errors } = await listUser(val);
      if (status) {
        this.userList = data;
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //进入图集
    intoPicList (id, index) {
      this.$router.push({
        //核心语句
        name: "pictureCenterAtlasShow", //跳转的路径
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          id: id,
          index: index
        },
      });
    },
    //检索姓名
    searchCon () {
      this.contributorFlag = -1
      if (this.contributor) {
        let data = { pageSize: 10, keyword: this.contributor, userType: 0 };
        this.listUserAsync(data);
      } else {
        let data = { pageSize: 10, userType: 0 };
        this.listUserAsync(data);
      }
    },
    //检索人物
    searchPeo () {
      this.peopleFaceFlag = -1
      if (this.peopleFaceSearch) {
        let data = { pageSize: 30, name: this.peopleFaceSearch, fuzzySearch: true };
        this.listPeopleAsync(data);
      } else {
        let data = { pageSize: 30 };
        this.listPeopleAsync(data);
      }
    },
    //滚动加载图库和图片
    scrollPic () {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;

      if (scrollTop + windowHeight + 5 >= scrollHeight) {
        if (this.isPic) {
          if (this.atlasList.length !== this.totalAtlas) {
            this.showLoading = true;
            setTimeout(() => {
              this.pageAtlas++;
              // console.log(this.page)
              this.showLoading = false;
              let params = {
                createUid: this.contributors.id !== -1 ? this.contributors.id : 0,
                keyword: this.keyword,
                libId: this.library.id !== -1 ? this.library.id : 0,
                timeStart: this.timeStart / 1000,
                timeEnd: this.timeEnd / 1000 + 86399,
                page: this.pageAtlas,
                pageSize: this.pageSizeAtlas,
                orderByTime: this.sort.id !== -1 ? this.sort.id : 0,
                status: 1,
                peopleId: this.peopleFace.id !== -1 ? this.peopleFace.id : 0
              };
              this.searchAtlasAsync(params);
            }, 1000);
          }
        } else {
          let labels = [];
          if (!this.environment && !this.theme) {
            labels = null;
          } else {
            if (this.environment) {
              if (this.environment.id !== -1) {
                labels.push(this.environment.id);
              }
            }
            if (this.theme) {
              if (this.theme.id !== -1) {
                labels.push(this.theme.id);
              }
            }

            labels = labels.join(",");
          }

          if (this.picList.length !== this.totalPic) {
            this.showLoading = true;
            setTimeout(() => {
              this.pagePic++;

              let paramspic = {
                createUid: this.contributors.id !== -1 ? this.contributors.id : 0,
                keyword: this.keyword,
                libId: this.library.id !== -1 ? this.library.id : 0,
                timeStart: this.timeStart / 1000,
                timeEnd: this.timeEnd / 1000 + 86399,
                takeStart: this.timeTakeStart / 1000,
                takeEnd: this.timeTakeEnd / 1000 + 86399,
                page: this.pagePic,
                pageSize: this.pageSizePic,
                orderByTime: this.sort.id !== -1 ? this.sort.id : 0,
                status: 1,
                peopleId: this.peopleFace.id !== -1 ? this.peopleFace.id : 0,
                peopleName: this.peopleFace.id !== -1 ? this.peopleFace.name : '',
                labels: labels
              };
              this.searchPictureAsync(paramspic);
            }, 1000);
          }
        }
      }
    },

    //获取图片邀约列表
    async listPictureNeedAsync (val) {
      let { status, data, message, pagination, errors } = await myPictureNeed(
        val
      );
      if (status) {
        this.picInviteList = data;

        this.myform.name = this.picInviteList[0].title;
        this.myform.id = this.picInviteList[0].id;
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取允许的推送渠道
    async listAllowPushChannelAsync () {
      let { status, data, message, errors } = await listAllowPushChannel();
      if (status) {
        this.pushList = data;
        this.template = this.pushList[0].template;
        this.pushdialogVisible = true;
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取图集中图片的编号
    async userGetAtlasSonIdsAsync (val, type, e) {
      let { status, data, message } = await getAtlasSonIds(val);
      if (status) {
        // console.log(data)
        let id = data.toString();
        // console.log(id)
        let choosePicMsg = {
          createUid: this.createUid,
          packageType: type,
          pictureCount: data.length,
          pictureIds: id,
          targetUid: this.userForm.user || 0,
          title: e ? e.name : this.userForm.name,
          pushConfig: JSON.stringify({
            pushChannelId: this.pushChannelId,
            note: e.note || "",
          }),
        };

        this.addPicturePackageAsync(choosePicMsg);
      } else {
        this.$message.error("失败！");
        this.mydialogVisible = false;
        this.pushdialogVisible = false;
      }
    },

    //获取图集中图片的编号
    async getAtlasSonIdsAsync (val, type, e) {
      let { status, data, message } = await getAtlasSonIds(val);
      if (status) {
        // console.log(data)
        let id = data.toString();
        // console.log(id)
        let choosePicMsg = {
          createUid: this.createUid,
          packageType: type,
          pictureCount: data.length,
          pictureIds: id,
          targetUid: 0,
          title: e ? e.name : this.myform.name,
          pushConfig: JSON.stringify({
            pushChannelId: this.pushChannelId,
            pictureNeedId: this.myform.id,
            note: this.myform.note,
          }),
        };

        this.addPicturePackageAsync(choosePicMsg);
      } else {
        this.$message.error("失败！");
        this.mydialogVisible = false;
        this.pushdialogVisible = false;
      }
    },
    //增加图片包
    async addPicturePackageAsync (val) {
      let { status, data, message, errors } = await addPicturePackage(val);
      if (status) {
        this.$message.success("创建成功！");
        this.mydialogVisible = false;
        this.pushdialogVisible = false;
        // this.setDrawer(false)
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
        this.mydialogVisible = false;
        this.pushdialogVisible = false;
      }
    },
    //获取人物列表
    async listPeopleAsync (val) {
      let { status, data, message } = await listPeople(val);
      if (status) {
        this.peopleFaceList = [];
        this.peopleFaceList = [
          {
            id: -1,
            name: "不限",
          },
        ];
        for (let i = 0; i < data.length; i++) {
          this.peopleFaceList.push({
            id: data[i].id,
            name: data[i].peopleName,
          });
        }

        console.log(this.peopleFaceList);
      }
    },
    //获取图片列表
    async listLibAsync () {
      let { status, data, message, pagination } = await listMyPowerLib();
      if (status) {
        this.libList = [];
        this.libList.push({
          id: -1,
          name: "不限",
        });
        console.log(this.allowLib);
        console.log(data);
        for (let i = 0; i < data.length; i++) {
          if (this.allowLib.indexOf(data[i].id.toString()) !== -1) {
            if (data[i].status === 1) {
              this.libList.push({
                id: data[i].id,
                name: data[i].name,
              });
            }
          }
        }
      }
    },
    //获取用户列表
    async listUserAsync (val) {
      let { status, data, message, pagination } = await listUser(val);
      if (status) {
        this.contributorList = [
          {
            id: -1,
            name: "不限",
          },
        ];
        for (let i = 0; i < data.length; i++) {
          if (data[i].status === 1) {
            if (data[i].userType === 0) {
              this.contributorList.push({
                id: data[i].id,
                name: data[i].name,
              });
            }
          }
        }
      }
    },
    //判断gril的row值
    checkRow () {
      this.displayResolution = document.documentElement.clientWidth;
      if (this.displayResolution > 2500) {
        this.row = 7;
        this.widthWithUP = "13%";
      } else if (this.displayResolution > 2400) {
        this.row = 6;
        this.widthWithUP = "14%";
      } else if (this.displayResolution > 2000) {
        this.row = 5;
        this.widthWithUP = "16%";
      } else if (this.displayResolution > 1700) {
        this.row = 5;
        this.widthWithUP = "18%";
      }
      if (this.displayResolution <= 1700) {
        this.row = 4;
        this.widthWithUP = "21.5%";
      }
      if (this.displayResolution <= 1600) {
        this.row = 4;
        this.widthWithUP = "22.5%";
      }
      if (this.displayResolution <= 1550) {
        this.row = 4;
        this.widthWithUP = "22.5%";
      }
      if (this.displayResolution <= 1400) {
        this.row = 3;
        this.widthWithUP = "25%";
      }
    },
    //检索图集
    async searchAtlasAsync (val) {
      let { status, data, message, pagination, errors } = await searchAtlas(
        val
      );
      this.showLoading = false;
      this.loading = false;
      if (status) {
        if (this.pageAtlas === 0) {
          this.atlasList = data;
        } else {
          for (let i = 0; i < data.length; i++) {
            this.atlasList.push(data[i]);
          }
        }
        if (this.atlasList.length == 0) {
          this.row = 1;
        } else {
          this.checkRow();
        }
        this.totalAtlas = pagination.total;
        for (let i = 0; i < this.atlasList.length; i++) {
          this.atlasList[i].mycreateAt = formatConversion(
            this.atlasList[i].createAt.toString()
          );

          if (
            this.atlasList[i].indexpicPath == "" &&
            this.atlasList[i].pictureCount !== 0
          ) {
            await generateIndexPic({
              atlasId: this.atlasList[i].id,
              isForce: true,
            });
          }

          if (this.atlasList[i].createUserInfo) {
            this.atlasList[i].createName = this.atlasList[
              i
            ].createUserInfo.name;
          } else {
            this.atlasList[i].createName = "暂无";
          }

          if (this.atlasList[i].indexpicPath === "") {
            this.atlasList[i].src = require("@/assets/house/onloadpic.png");
          } else {
            this.atlasList[i].src = picPrefix + this.atlasList[i].indexpicPath;
          }

          if (this.atlasList[i].pictureCount == 0) {
            this.atlasList[i].src = require("@/assets/house/onloadpic.png");
          }
        }

        this.$forceUpdate();
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //获取图集信息
    async listAtlasPicturesAsync () {
      let { status, data, message, pagination } = await listAtlasPictures({ id: this.$route.query.id });
      if (status) {
        // this.atlasInfo = data
        // this.atlasInfo.createAtMY = formatConversion(this.atlasInfo.createAt.toString())
        // this.createUserInfoname = data.createUserInfo.name
        // console.log(this.atlasInfo)
        for (let i = 0; i < data.length; i++) {
          errorPic(data[i], data[i].fileInfo.picThumbH160, this.picPrefix)
          data[i].picH = data[i].fileInfo.picH
          data[i].picW = data[i].fileInfo.picW
          data[i].resourceId = data[i].id
          data[i].srcW1080 = this.picPrefix + data[i].fileInfo.picThumbW1080

        }
        this.picList = data
      }
      console.log(data);
    },


    //检索图片
    async searchPictureAsync (val) {

      if (this.isForestall) {
        let { status, data, message, pagination, errors } = await advSearchPicture(
          val
        );
        this.searchLoading = false;
        this.loading = false;
        if (status) {
          if (this.pagePic === 0) {
            this.picList = data;
          } else {
            for (let i = 0; i < data.length; i++) {
              this.picList.push(data[i]);
            }
          }
          this.totalPic = pagination.total;


          for (let i = 0; i < this.picList.length; i++) {
            if (this.picList[i].picThumbH160) {
              this.picList[i].src =
                picPrefix + this.picList[i].picThumbH160;
              this.picList[i].srcW1080 =
                picPrefix + this.picList[i].picThumbW1080;
            } else {
              this.picList[i].src = require("@/assets/house/onloadpicin.png");
              this.picList[
                i
              ].srcW1080 = picPrefix + this.picList[i].savepath;
            }


            //图片加载失败
            if (this.picList[i].picThumbH160 === "error") {
              this.picList[i].errortext = "error";
              this.picList[
                i
              ].src = require("@/assets/house/onloadpicerror.png");
              this.picList[
                i
              ].picThumbWh160 = require("@/assets/house/onloadpicerror.png");
              this.picList[
                i
              ].srcW1080 = picPrefix + this.picList[i].savepath;
            }
            let imgTest = new Image();
            imgTest.src = this.picList[i].src;
            imgTest.onerror = () => {
              this.picList[i].errortext = "error";
              this.picList[
                i
              ].src = require("@/assets/house/onloadpicerror.png");
              this.picList[
                i
              ].picThumbWh160 = require("@/assets/house/onloadpicerror.png");
              this.picList[
                i
              ].srcW1080 = picPrefix + this.picList[i].savepath;
            };

          }

          let picLoveString = sessionStorage.getItem("picLove");
          let picLoveArray = JSON.parse(picLoveString);
          if (picLoveArray) {
            for (let j = 0; j < picLoveArray.length; j++) {
              for (let z = 0; z < this.picList.length; z++) {
                if (picLoveArray[j].resourceId === this.picList[z].resourceId) {
                  this.loveList.push(picLoveArray[j].resourceId);
                  this.picList[z].isLove = true;
                }
              }
            }
            this.setLoveList(this.loveList);
          } else {
            this.loveList = [];
            this.setLoveList(this.loveList);
          }

          this.$forceUpdate();



        } else {
          let errortext = "";
          for (const key in errors) {
            errortext += errors[key];
          }
          this.$message.error({ message: message + errortext });
        }
      } else {
        let { status, data, message, pagination, errors } = await searchPicture(
          val
        );
        this.searchLoading = false;
        this.loading = false;
        if (status) {
          if (this.pagePic === 0) {
            this.picList = data;
          } else {
            for (let i = 0; i < data.length; i++) {
              this.picList.push(data[i]);
            }
          }
          this.totalPic = pagination.total;


          for (let i = 0; i < this.picList.length; i++) {
            if (this.picList[i].fileInfo) {
              if (!this.picList[i].fileInfo.picThumbH160) {
                this.picList[i].src = require("@/assets/house/onloadpicin.png");

                this.picList[
                  i
                ].srcW1080 = picPrefix + this.picList[i].fileInfo.savepath;
              } else {
                this.picList[i].src =
                  picPrefix + this.picList[i].fileInfo.picThumbH160;
                this.picList[i].srcW1080 =
                  picPrefix + this.picList[i].fileInfo.picThumbW1080;
              }
              //图片加载失败
              if (this.picList[i].fileInfo.picThumbH160 === "error") {
                this.picList[i].errortext = "error";
                this.picList[
                  i
                ].src = require("@/assets/house/onloadpicerror.png");
                this.picList[
                  i
                ].picThumbWh160 = require("@/assets/house/onloadpicerror.png");
                this.picList[
                  i
                ].srcW1080 = require("@/assets/house/onloadpicerror.png");
              }
              let imgTest = new Image();
              imgTest.src = this.picList[i].src;
              imgTest.onerror = () => {
                this.picList[i].errortext = "error";
                this.picList[
                  i
                ].src = require("@/assets/house/onloadpicerror.png");
                this.picList[
                  i
                ].picThumbWh160 = require("@/assets/house/onloadpicerror.png");
                this.picList[
                  i
                ].srcW1080 = require("@/assets/house/onloadpicerror.png");
              };
            } else {
              this.picList[i].src = require("@/assets/house/onloadpic.png");
              this.picList[
                i
              ].picThumbWh160 = require("@/assets/house/onloadpic.png");
              this.picList[i].srcW1080 = require("@/assets/house/onloadpic.png");
            }

            if (this.picList[i].exif && this.isJSON(this.picList[i].exif)) {
              this.picList[i].exif = JSON.parse(this.picList[i].exif);
            }

            this.picList[i].isLove = false;
          }
          // console.log('1',this.picList)
          let picLoveString = sessionStorage.getItem("picLove");
          let picLoveArray = JSON.parse(picLoveString);
          if (picLoveArray) {
            for (let j = 0; j < picLoveArray.length; j++) {
              for (let z = 0; z < this.picList.length; z++) {
                if (picLoveArray[j].id === this.picList[z].id) {
                  this.loveList.push(picLoveArray[j].id);
                  this.picList[z].isLove = true;
                }
              }
            }
            this.setLoveList(this.loveList);
          } else {
            this.loveList = [];
            this.setLoveList(this.loveList);
          }

          this.$forceUpdate();

        } else {
          let errortext = "";
          for (const key in errors) {
            errortext += errors[key];
          }
          this.$message.error({ message: message + errortext });
        }
      }
      this.showLoading = false;
      this.showGifFlag = false;
      console.log(this.picList);
    },
    isJSON (str) {
      if (typeof str == "string") {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == "object" && obj) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          console.log("error：" + str + "!!!" + e);
          return false;
        }
      }
      // console.log('It is not a string!')
    },
    //图片右击
    rightShow (e) {
      this.rightMouseLeft = e.clientX;
      this.rightMouseTop = e.clientY;
      setTimeout(() => {
        this.rightMouseFlag = true;
      }, 200);
      setTimeout(() => {
        this.rightMouseFlag = false;
      }, 2000);
      // this.$message('版权所有')
    },

    //设置选用图片
    async setUserSettingAsync (val, val2, data1) {
      let { status, data, message, errors } = await setUserSetting(
        val,
        val2,
        data1
      );
      if (status) {
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取选用图片
    async getUserSettingAsync (val, val2) {
      let { status, data, message, errors } = await getUserSetting(val, val2);
      if (status) {
        let piclove = JSON.parse(data);
        // console.log(piclove);
        if (piclove.value == null) {
          sessionStorage.removeItem("picLove");
        } else {
          let picIds = [];
          for (let i = 0; i < piclove.value.length; i++) {
            picIds.push(piclove.value[i].id);
          }
          picIds = picIds.join(",");
          // console.log(picIds);
          let idsInfo = await getPictures({ ids: picIds });
          for (let j = 0; j < idsInfo.data.length; j++) {
            idsInfo.data[j].srcW1080 =
              this.picPrefix + idsInfo.data[j].fileInfo.picThumbW1080;
            idsInfo.data[j].src =
              this.picPrefix + idsInfo.data[j].fileInfo.picThumbH160;
          }
          // console.log(idsInfo.data);
          sessionStorage.setItem("picLove", JSON.stringify(idsInfo.data));
        }
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },
  },
  created () {

    window.onresize = () => {
      if (!checkFull()) {
        // 退出全屏后要执行的动作
        // console.log("退出全屏")
        this.seeFull = false;
        this.$store.commit("SET_BigImage", false);
      }
    };


    //搜索内容
    //获取图库列表
    this.listLibAsync();

    //获取投稿人列表
    this.listUserAsync({ pageSize: 10, userType: 0 });

    //获取人物列表
    this.listPeopleAsync({ pageSize: 30 });

    this.getUserSettingAsync(this.createUid, "picLove");

    //检索
    //获取图集
    // this.showLoading = true;
    // this.searchAtlasAsync({
    //   pageSize: this.pageSizeAtlas,
    //   page: this.pageAtlas,
    //   status: 1,
    // });
    this.searchFlag = false
    this.centerSearch()

    //获取图片
    // for (let i = 0; i < 20; i++) {
    //   let nopic = {
    //     src: require("@/assets/house/grey.png")
    //   };
    //   this.picList.push(nopic);
    // }
    // setTimeout(() => {
    //   this.searchPictureAsync({
    //     pageSize: this.pageSizePic,
    //     page: this.pagePic
    //   });
    // }, 1000);
  },
  mounted () {
    window.addEventListener("scroll", this.scrollPic);
    //获取侧边栏是否收起
    // this.bus.$on("changeIsaside", (message) => {
    //   this.bus.val = message;
    //   this.isAside = this.bus.val;
    // });
  },
  destroyed () {
    //离开这个界面之后，删除，不然会有问题
    window.removeEventListener("scroll", this.scrollPic);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./photocenter.scss";
@import "@/constants/elHeader.scss";
// /deep/ .el-select__caret:before {
//   content: "\e78f";
//   font-size: 16px;
//   color: black;

// }
/deep/ .el-input__prefix {
  display: none;
}
/deep/ .el-input__inner {
  padding-left: 18px;
}
.seePic /deep/ .el-dialog__header {
  display: none;
}
.seePic /deep/ .el-dialog__body {
  display: flex;
  padding: 0;
}

//改变图片放大的关闭的位置
/deep/ .el-image-viewer__close {
  width: 5000px;
  height: 5000px;
  border-radius: 0%;
}
/deep/ .el-icon-circle-close {
  margin-top: 100px;
  color: white;
}

/deep/ .image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
